import { render } from "./TrainingSession.vue?vue&type=template&id=349ce250&scoped=true&ts=true"
import script from "./TrainingSession.vue?vue&type=script&lang=ts"
export * from "./TrainingSession.vue?vue&type=script&lang=ts"

import "./TrainingSession.vue?vue&type=style&index=0&id=349ce250&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349ce250"]])

export default __exports__